import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { createPageUrl } from "@/utils";
import { Tv, Video, Music, Settings, Menu, X, Radio } from "lucide-react";

const navItems = [
  { label: "TV en Vivo", icon: Tv, page: "TvEnVivo" },
  { label: "Videos", icon: Video, page: "Videos" },
  { label: "Audio MP3", icon: Music, page: "AudioMP3" },
  { label: "Administración", icon: Settings, page: "Administracion" },
];

export default function Layout({ children, currentPageName }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="flex min-h-screen bg-background font-sans">
      {/* Overlay móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full w-64 bg-primary text-primary-foreground z-30 flex flex-col transition-transform duration-300
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 lg:static lg:flex`}
      >
        {/* Logo */}
        <div className="flex items-center justify-between px-4 py-5 border-b border-white/20">
          <div className="flex items-center gap-3">
            <img
              src="https://cdn.agentui.ai/cmpld23q31gz7s52cbdjtsvhm/1779724039839-c5f827e2/luismusictvbarza.png"
              alt="LUISMUSICTVS"
              className="h-10 w-10 rounded-full object-cover"
            />
            <div>
              <p className="font-black text-sm leading-tight">LUISMUSICTVS</p>
              <p className="text-xs text-white/60">Entretenimiento</p>
            </div>
          </div>
          <button
            className="lg:hidden text-white/80 hover:text-white"
            onClick={() => setSidebarOpen(false)}
          >
            <X size={20} />
          </button>
        </div>

        {/* En vivo badge */}
        <div className="mx-4 mt-4 mb-2 flex items-center gap-2 bg-accent text-accent-foreground rounded px-3 py-2">
          <Radio size={14} className="animate-pulse" />
          <span className="text-xs font-bold">EN VIVO AHORA</span>
        </div>

        {/* Navegación */}
        <nav className="flex-1 px-3 py-2 space-y-1">
          {navItems.map(({ label, icon: Icon, page }) => {
            const href = createPageUrl(page);
            const isActive = currentPageName === page;
            return (
              <Link
                key={page}
                to={href}
                onClick={() => setSidebarOpen(false)}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all text-sm font-semibold
                  ${isActive
                    ? "bg-white/20 text-white shadow"
                    : "text-white/75 hover:bg-white/10 hover:text-white"
                  }`}
              >
                <Icon size={18} />
                {label}
              </Link>
            );
          })}
        </nav>

        {/* Footer sidebar */}
        <div className="px-4 py-4 border-t border-white/20 text-xs text-white/40 text-center">
          © 2025 LUISMUSICTVS
        </div>
      </aside>

      {/* Contenido principal */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Topbar móvil */}
        <header className="lg:hidden flex items-center gap-3 px-4 py-3 bg-primary text-primary-foreground sticky top-0 z-10 shadow">
          <button onClick={() => setSidebarOpen(true)}>
            <Menu size={22} />
          </button>
          <img
            src="https://cdn.agentui.ai/cmpld23q31gz7s52cbdjtsvhm/1779724039839-c5f827e2/luismusictvbarza.png"
            alt="LUISMUSICTVS"
            className="h-8 w-8 rounded-full object-cover"
          />
          <span className="font-black text-sm">LUISMUSICTVS</span>
        </header>

        {/* Página */}
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
}